import { render, staticRenderFns } from "./OrderDialog.vue?vue&type=template&id=ab91b5b6&scoped=true&"
import script from "./OrderDialog.vue?vue&type=script&lang=js&"
export * from "./OrderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab91b5b6",
  null
  
)

export default component.exports